import React from 'react';
import {
  Route,
}                                 from 'react-router-dom';
import List                       from './List';
import { PartnersDashboardProvider }        from './context';

function Peoples(){
  return(
    <PartnersDashboardProvider>
      <Route component={List} />
    </PartnersDashboardProvider>
  );
}
export default React.memo(Peoples);
